
var onSale = false;
var soldOut = false;
var priceVaries = false;
let position = --boostPFSThemeConfig.custom.adPosition;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style1',
    loadPreviousType: 'infinite',
	},
};

(function() {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100

		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {


		if (!data) data = this.data;
		if (!index) index = this.index;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

		//Add class
		itemHtml = itemHtml.replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_row);
		itemHtml = itemHtml.replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_row);
		itemHtml = itemHtml.replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_row );

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));
		if( Shopify.locale == 'fr' ) {
			itemHtml = itemHtml.replace(/{{QuickView}}/g, '<a class="product-modal Button Button--primary" href="{{itemUrl}}?view=quick">APERÇU</a>');
		} else {
			itemHtml = itemHtml.replace(/{{QuickView}}/g, '<a class="product-modal Button Button--primary" href="{{itemUrl}}?view=quick">Quick View</a>');
		}


		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));
		itemHtml = itemHtml.replace(/{{itemCustomSwatches}}/g, buildCustomSwatchs(data));
		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
		itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
		itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if (typeof Utils.compileShopifyProductVariables == 'function') {
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
		}

		if (typeof Utils.compileShopifyProductMetafield == 'function') {
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
		}
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

	function buildImage(data, images) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0){
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 480,
				height: 480
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
			}
			htmlImg += '" data-product-id="' + data.id + '">';

			/* product tile image carousel */
			var alternate_images = [];
			if (has_alternate_image) {
				htmlImg += '<script>';

				if ( images.length > 1 ) {
					for ( var k = 0; k < images.length; k++ ) {
						if ( ! ( images[k]['alt'] == 'featured' || images[k]['alt'] == 'featured mobile' || ( images[k]['alt'] && images[k]['alt'].indexOf('swatch') !== -1 ) ) ) {
							alternate_images.push(Utils.optimizeImage(images[k]['src'], 'grande'));
						}
					}
				}

				htmlImg += 'preload_images('+ JSON.stringify( alternate_images ) + ');';
				htmlImg += 'var loop_' + data.id + ';';
				htmlImg += 'var i_' + data.id + ' = 0;';
				htmlImg += 'jQuery(document).ready(function($) {';
					htmlImg += 'var data_image = ' + JSON.stringify( alternate_images ) + ';';
						htmlImg += 'var current_' + data.id + ' = jQuery(".ProductItem__ImageWrapper[data-product-id=' + data.id + ']").find(".ProductItem__Image--alternate");';
						htmlImg += 'var temp_store_' + data.id + ' = current_' + data.id + '.attr( "src" );';

						htmlImg += 'jQuery(".ProductItem__ImageWrapper[data-product-id=' + data.id + ']").mouseover(function(event) {';

							htmlImg += 'loop_' + data.id + ' = setInterval(function() {';
								htmlImg += 'if ( i_' + data.id + ' < data_image.length - 1) {';
									htmlImg += 'i_' + data.id + '++;';
									htmlImg += 'current_' + data.id + '.attr( "src", data_image[i_' + data.id + '] );';
								htmlImg += '} else {';
									htmlImg += 'i_' + data.id + ' = 0;';
									htmlImg += 'current_' + data.id + '.attr( "src", data_image[i_' + data.id + '] );';
								htmlImg += '}';
							htmlImg += '}, 1000 );';

						htmlImg += '}).mouseout(function() {';
							htmlImg += 'clearInterval(loop_' + data.id + ');';
							htmlImg += 'i_' + data.id + ' = 0;';
							htmlImg += 'current_' + data.id + '.attr( "src", temp_store_' + data.id + ' );';
					htmlImg += '});';
				htmlImg += '});';
				htmlImg += '</script>';
			}
			/* --product tile image carousel */

			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';

			if (has_alternate_image && images.length > 1) {
				var sizes = '200,300,400,600,800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				// var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
				// htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
				var thumbUrl = Utils.optimizeImage(images[1]['src'], 'grande');
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" src="' + thumbUrl + '" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
			}

			var sizes_main = '200,400,600,700,800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var imageclass = "product_main_image_"+data.id;
			var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;
			htmlImg += '<img class="'+imageclass+' ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
			htmlImg += '<span class="Image__Loader"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '</noscript>';

			// Badge Icon
			var productBadgeIconHtml = getTagData(data,'icon_','icon-image');
			if( productBadgeIconHtml.hasTag ){
				var productIconImgName = productBadgeIconHtml.tagData.replace("icon_", "").concat("-icon.png").toLowerCase();
				var productBadgeImgUrl = getPathFromUrl( boostPFSAppConfig.general.file_url ) + productIconImgName.replace( 'swatch_url_source_do_not_remove.png', productIconImgName );
				productblurbHtml = boostPFSAppConfig.general.blurb_text;
				htmlImg += '<div class="icon-image">'+
						'<img src="'+productBadgeImgUrl+'" alt="Icon badge" ' + ( productblurbHtml ? 'title="'+ productblurbHtml + '"' : '' ) + '>'+
				'</div>';
			}

			htmlImg += '</div>';
			htmlImg += '</a>';
		}
		return htmlImg;
	}

	function getPathFromUrl(url) {
		return url.split("?")[0];
	}

	function imageSize(sizes, image) {
		if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}

			if (supported_sizes == '') supported_sizes = image.width;

			if(!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}

	function buildPrice(data) {
		// console.log(data.tags);
		var ptags = data.tags;
		for (let i = 0; i < ptags.length; i++) {
		  if(ptags[i].indexOf("msrpprice:") != -1){
			  var msrpprice = ptags[i].substr(10);
		  }
		}
		  var html = '';
		  var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		  var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		  html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
		  if (onSale) {
			  html += '<span class="ProductItem__Price Price Price--highlight Text--subdued text1" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
			if(msrpprice != null){
			html += '<span style="margin:0 10px; padding:0 !important;" class="ddddd ProductItem__Price Price Price--compareAt Text--subdued text2" data-money-convertible>' +  msrpprice + '</span>';
			}else{
				html += '<span class="ddddd ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
			}
		  } else {

			  if (priceVaries) {
				  html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
			  } else {
				  html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
			  }
		   /* if(msrpprice != null){
			html += '<span class="ddddd ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible style="margin:0 10px; padding:0 !important;">' +  msrpprice + '</span>';
			}*/
		  }
		  html += '</div>';
		  return html;
	  }

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
		if (boostPFSThemeConfig.custom.show_labels) {
			product_labels = '';
			var tags = data.tags;
			for (var k = 0; k < tags.length; k++) {
				var tag = tags[k];
				if (tag.indexOf('__label') != -1) {
				product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
				break;
				}
			}
			if (!soldOut) {
				if (onSale)
					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
			} else {
				product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
			}

			if (product_labels != '') {
				html += '<div class="ProductItem__LabelList">';
				html += product_labels;
				html += '</div>';
			}
		}
		return html;
	}

	function buildCustomSwatchs(data) {
		var colorhtml = "";
		var finalcolorhtml = "";
		var ptags = data['tags'];

		if (Shopify.locale == "en") {
			var colortext = " COLORS";
		}
		if (Shopify.locale == "fr") {
			var colortext = " COULEURS";
		}

		var totalcolors = 1;
		var colorHandles = [];

		ptags.forEach(function (tag) {
			if (tag.indexOf("color:") >= 0) {
				totalcolors = totalcolors + 1;
				colorHandles.push(tag.replace("color:", "").trim());
			}
		});

		if (totalcolors > 1) {
			var handle = "/products/" + data.handle;
			colorhtml += '<div class="custom_swatch">';
			colorhtml += '<a class="total_colors_count" href="' + handle + '" data-color-handles="' + colorHandles.join(',') + '" data-color-text="' + colortext + '">' + totalcolors + colortext + '</a>';
			colorhtml += '</div>';
		}

		if (colorhtml != "") {
			var finalcolorhtml = '<div class="swatches_custom swatches-type-collections hover-enabled">';
			finalcolorhtml += colorhtml;
			finalcolorhtml += '</div>';
		}

		return finalcolorhtml;
	}
	function buildInfo(data, indx) {
		var settings_pattern1 = jQuery("#settings_pattern1").val();
        var settings_pattern2 = jQuery("#settings_pattern2").val();
        var msg1_enable = "";
        var msg2_enable = "";
        var msg1_coll = jQuery("#msg1_coll").val();
        var msg2_coll = jQuery("#msg2_coll").val();
        // Only accept real CSS color values (hex/rgb/hsl). Guards against the
        // translation app rewriting empty settings into text on non-EN locales.
        var bogoColorRegex = /^(#|rgba?\(|hsla?\()/i;
        var msg1_color = jQuery("#msg1_color").val() || "";
        var msg1_color_css = bogoColorRegex.test(msg1_color) ? msg1_color : "var(--product-sale-price-color)";
        var msg2_color = jQuery("#msg2_color").val() || "";
        var msg2_color_css = bogoColorRegex.test(msg2_color) ? msg2_color : "var(--product-sale-price-color)";
        let dis1 = "";
        let dis2 = "";
		if(boostPFSThemeConfig.custom.currentLanguage == "EN"){	
		var bogomsg = jQuery("#settings_msg_en").val();
		var settings_msg1 = jQuery("#settings_msg1_en").val();
        var settings_msg2 = jQuery("#settings_msg2_en").val();
		}
		else{
			var bogomsg = jQuery("#settings_msg_es").val();
			var settings_msg1 = jQuery("#settings_msg1_es").val();
			var settings_msg2 = jQuery("#settings_msg2_es").val();
		}
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var ptags = data.tags;
			for (let i = 0; i < ptags.length; i++) {
			// console.log(ptags[i].indexOf("BOGO50"));
			if(ptags[i].indexOf("BOGO50") != -1 || ptags[i].indexOf("bogo50") != -1){
				var bogo_enable = "yes";
			}
			if(settings_pattern1 != "" && ptags[i].indexOf(settings_pattern1) != -1){
				var msg1_enable = "yes";  
				dis1 = ptags[i].replace(settings_pattern1,"");
			 }
			 if(settings_pattern2 != "" && ptags[i].indexOf(settings_pattern2) != -1){
			   var msg2_enable = "yes";
			   dis2 = ptags[i].replace(settings_pattern2,"");
			 }
			}
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="ProductItem__Info ' + infoClass + ' ">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
			}

			html += '<h2 class="ProductItem__Title Heading">';
			html += '<a href="{{itemUrl}}">' + data.title + '</a>';
			html += '</h2>';
			html += '<a id="reviews-click" href="#" data-redirect="{{itemUrl}}#reviews-yotpo-div">';
			html += '{{itemReviews}}';
			if(bogo_enable == "yes"){
				html += '<h2 class="ProductItem__Title Heading" style="color: var(--product-sale-price-color) !important; font-size: 12px !important; width: 100%; text-align: center">';
				html += bogomsg;
				html += '</h2>';
			  }
			  if(msg1_coll == "true" && msg1_enable == "yes"){
				html += '<h2 class="ProductItem__Title Heading message1" style="color: ' + msg1_color_css + ' !important; font-size: 12px !important; width: 100%; text-align: center">';
				html += settings_msg1.replace("%s",dis1);
				html += '</h2>';
			  }
		  if(msg2_coll == "true" && msg2_enable == "yes"){
				html += '<h2 class="ProductItem__Title Heading message2" style="color: ' + msg2_color_css + ' !important; font-size: 12px !important; width: 100%; text-align: center">';
				html += settings_msg2.replace("%s",dis2);
				html += '</h2>';
			  }
			html += '</a>';
			html += buildPrice(data);
			if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx);
			}
			html += '</div>';
		}

		return html;
	}

	function buildSwatch(data, indx) {
		var itemSwatchHtml = '';
		if (boostPFSThemeConfig.custom.show_color_swatch) {
		var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
		data.options_with_values.forEach(function (option, index) {
			var option_name = option.name.toLowerCase();
			if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
			var values = '';
			itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
			var i = 0;
			data.variants.forEach(function (variant) {
				var temp = variant.merged_options.filter(function (obj) {
					obj = obj.toLowerCase();
					if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
						return obj;
				});
				temp = temp[0].split(':');

				var value = temp[1].toLowerCase();
				if (values.indexOf(value) == -1) {
					values = values + ',' + value;
					values = values.split(',');
					var size = '200,400,600,700,800,900,1000,1200';
					var supported_sizes = imageSize(size, variant.image);
					var color_image = Utils.optimizeImage(variant.image);
					var name_color = Utils.slugify(value) + '.png';
					var checked = (i == 0) ? 'checked=checked' : '';
					var imageInfo = null;
					var image_aspect_ratio = 1;
					imageInfo = data.images_info.find(function (imageOb) {
						if (imageOb.src == variant.image){
							image_aspect_ratio = imageOb.width / imageOb.height;
						return imageOb;
						}
					});
					if (!imageInfo){
						if (data.images_info.length > 0){
							imageInfo = data.images_info[0];
						} else {
							imageInfo = {
							src: boostPFSConfig.general.no_image_url,
								id: variant.id,
								width: 480,
								height: 480
							}
						}

					}
					var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
					var color_input_id = color_name + "-" + values.length;
					var variant_price = variant.price ? variant.price : 0;
					var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
					var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
					itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
					itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
					itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
					itemSwatchHtml += '</div>';
					i++;
				}
			});
			itemSwatchHtml += '</div>';
			}
		});
		}
		return itemSwatchHtml;
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').on('click',function(e) {
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			jQ('.CollectionToolbar__Item--sort').trigger('click');
		});
	}
	/************************** END BUILD TOOLBAR **************************/

	// Async-correct the color count by verifying each linked product's availability
	function updateColorCountsAsync() {
		document.querySelectorAll('.total_colors_count[data-color-handles]').forEach(function(link) {
			var handles = link.getAttribute('data-color-handles').split(',').filter(Boolean);
			var colortext = link.getAttribute('data-color-text') || ' COLORS';
			if (!handles.length) return;

			Promise.all(handles.map(function(h) {
				return fetch('/products/' + h + '.js', { method: 'GET' })
					.then(function(r) { return r.ok ? r.json() : null; })
					.catch(function() { return null; });
			})).then(function(products) {
				var availableCount = 1; // current product itself
				products.forEach(function(p) {
					if (p && p.available) availableCount++;
				});
				link.removeAttribute('data-color-handles');
				link.removeAttribute('data-color-text');
				if (availableCount > 1) {
					link.textContent = availableCount + colortext;
				} else {
					var wrapper = link.closest('.swatches_custom');
					if (wrapper) wrapper.style.display = 'none';
				}
			});
		});
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;

		// Update color counts based on actual product availability
		updateColorCountsAsync();

		/**
		 *  Call theme function
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}
		*/

		// Fix image not load on Instagram browser - initialize swatch image
		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").on('click',function() {
			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
			jQ(this).addClass('active');
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');
			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
			productImage.find('img.ProductItem__Image').hide();
			productImage.attr('href', variantInfo.data('variant-url'));
			var variantPrice = '';
			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
			} else {
				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
			}
			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
		})

		//Change view layout
		var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
		if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
		}
		var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
		if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/'+ boostPFSThemeConfig.custom.mobile_row + '--phone');
			jQ(Selector.products + ' .Grid__Cell').addClass('1/'+ mobileView + '--phone');
		}

		//identify and remove pre existing ad
		var preExistingAds = jQ(".ProductList").find(".ad-block-content");
		if( preExistingAds.length > 0 ){
			preExistingAds.each( function( i, v ){
				jQ(v).remove();
			} );
		}

		//get the dom count after the removed pre existing dom
		var klarnaTileRender = jQ(".ProductList").find(".Grid__Cell");
		let fitOnValues = Math.round( klarnaTileRender.length / position );

		//process and construct the postion
		let displacement = [];
		if( boostPFSThemeConfig.custom.adRepeat ){
			for(i = 1; i <= fitOnValues; i++){
				displacement.push( i * position );
			}
		} else {
			displacement.push( position );
		}

		//loop the position and insert image
		if( boostPFSThemeConfig.custom.adEnable != "false" ){
			jQ( displacement ).each( function(i, v){
				if( typeof klarnaTileRender[v] !== "undefined" && klarnaTileRender[v] ){
					let url = boostPFSThemeConfig.custom.currentLanguage == "EN" ? boostPFSThemeConfig.custom.adBlockUrlCa != "#" ? boostPFSThemeConfig.custom.adBlockUrlCa : 'javascript:void(0)' : boostPFSThemeConfig.custom.adBlockUrlFr != "#" ? boostPFSThemeConfig.custom.adBlockUrlFr : 'javascript:void(0)';
					let itemHtml = '<div id="ad-block-content-'+i+'" class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk ad-block-content">';
						itemHtml += '<div class="AspectRatio AspectRatio--withFallback"><a href="' + url + '" ' + (boostPFSThemeConfig.custom.adTarget && boostPFSThemeConfig.custom.adTarget != "#" ? 'target="_blank"' : '') + '>'
						itemHtml += '<img src="' + boostPFSThemeConfig.custom.adImage + '" alt="' + boostPFSThemeConfig.custom.adAlt + '" />';
						itemHtml += '<div class="content-add">';
						itemHtml += '<p class="content-add-text">'+ boostPFSThemeConfig.custom.adText +'</p>';
						itemHtml += '<a href="'+ url +'" ' + (boostPFSThemeConfig.custom.adTarget && boostPFSThemeConfig.custom.adTarget != "#" ? 'target="_blank"' : '') + ' class="Button Button--primary">'+ boostPFSThemeConfig.custom.adOptionText +'</a>';
						itemHtml += '</div>';
						itemHtml += '</a></div>';
						itemHtml += '</div>';
					jQ( itemHtml ).insertBefore( klarnaTileRender[v] );
				}
			});
		}
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
	};

  FilterApi.beforeCall = function(){
    if(Globals.queryParams.tag !== null &&
       Globals.queryParams.tag.length > 0 &&
       boostPFSConfig.general.current_locale == "fr" &&
       Utils.isCollectionPage() && Utils.isTagPage()){
		var tag = [window.location.pathname.split(boostPFSAppConfig.general.collection_handle)[1].replace("/" , "")];
        if(Globals.queryParams.tag.indexOf(tag[0]) === -1){
			Globals.queryParams.tag = tag
        }

    }
  }

	// Build Default layout
	Filter.prototype.errorFilterCallback = function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};
})();

// Common function which checks for the tag and returns its html to replace
function getTagData(data, prodTag, elementClasses) {
  // Check if has badge tag
  var tagData = '';
  var hasTag = data.tags.filter(function (tag) {
    tag = tag.toLowerCase().trim();
    return tag.indexOf(prodTag) > -1, ( tag.indexOf(prodTag) > -1 ? tagData = tag : '');
  }).length;
  // In case the classes paramter has not been passed
  elementClasses = elementClasses || '';
  // Return the item html
  var itemTagHtml = hasTag ? '<div class="'+ elementClasses +'"></div>' : '';
  return { hasTag, tagData, itemTagHtml };
}
